import moment from 'moment/moment';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { RootStateOrAny, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';

function TimeRemind({ serveType, webStoreVo }) {
  const projectName = useSelector<RootStateOrAny, any>(
    (state) => state.modeReducer.projectName
  );

  if (!serveType) {
    serveType = useSelector<RootStateOrAny, any>(
      (state) => state.modeReducer.serveType
    );
  }

  let lastPickupTime;
  if (webStoreVo) {
    const { takeoutSchedules, endTime } = webStoreVo;

    // 目前v1邏輯
    if (endTime) {
      lastPickupTime = moment(endTime, 'HH:mm')
        .add(30, 'minutes')
        .format('HH:mm');
    }

    if (
      takeoutSchedules &&
      takeoutSchedules.length > 0 &&
      takeoutSchedules[0].timePeriods &&
      takeoutSchedules[0].timePeriods.length > 0
    ) {
      lastPickupTime = takeoutSchedules[0].timePeriods[0].endTime.split('+')[0];
    }
  }

  const checkPreorderTimeMap = () => {
    if (
      Object.keys(
        webStoreVo?.preorderTimeMap?.SCHEDULE_TAKE_OUT?.availableTimes
      ).length === 0
    ) {
      if (
        webStoreVo?.takeoutSchedules?.length > 1 ||
        webStoreVo?.takeoutSchedules?.length === 0
      ) {
        return false;
      }
      return true;
    }
    return false;
  };

  const formatAvailableTakeOutServeTimes = () => {
    const availableTimePeriods = webStoreVo?.takeoutSchedules?.[0].timePeriods;

    if (!availableTimePeriods) return '';

    let formatTimePeriods = ' ';
    for (let i = 0; i < availableTimePeriods.length; i += 1) {
      const startTime = cloneDeep(availableTimePeriods[i].startTime).slice(
        0,
        5
      );
      const endTime = cloneDeep(availableTimePeriods[i].endTime).slice(0, 5);
      const tempTimePeriods = startTime + '~' + endTime;
      formatTimePeriods += tempTimePeriods;
      if (i + 1 < availableTimePeriods.length) formatTimePeriods += ' || ';
    }

    return formatTimePeriods;
  };

  const checkTakeoutEnableCrossDay = () => {
    const availableTimePeriods = webStoreVo?.takeoutSchedules;
    if (availableTimePeriods.length > 0) {
      return false;
    }

    return true;
  };

  switch (serveType) {
    case 'DINE_IN':
      return null;
    case 'TAKE_OUT':
      return (
        <div>
          <div>
            {projectName === 'PHISON' && checkTakeoutEnableCrossDay() ? (
              <div
                className="d-flex align-items-center"
                style={{
                  color: '#FF8A80',
                  fontSize: '12px',
                  paddingTop: '20px',
                }}
              >
                <div
                  style={{ color: '#FF8A80', fontSize: '5px', padding: '5px' }}
                >
                  ●
                </div>
                <FormattedMessage
                  id="welcome.button.bussiness.time"
                  values={{
                    startTime: webStoreVo?.startTime,
                    endTime: webStoreVo?.endTime,
                  }}
                />
              </div>
            ) : (
              ''
            )}
          </div>

          <div>
            {projectName === 'PHISON' && checkPreorderTimeMap() ? (
              <div
                className="d-flex"
                style={{
                  color: '#FF8A80',
                  fontSize: '12px',
                  paddingTop: '20px',
                }}
              >
                <div
                  style={{ color: '#FF8A80', fontSize: '5px', padding: '5px' }}
                >
                  ●
                </div>
                <FormattedMessage
                  id="welcome.availableTakeOutServeTimes"
                  values={{
                    startTime: webStoreVo?.startTime,
                    endTime: webStoreVo?.endTime,
                    timePeriods: formatAvailableTakeOutServeTimes(),
                  }}
                />
              </div>
            ) : (
              ''
            )}
          </div>
          <div
            className="d-flex"
            style={{ color: '#5292D9', fontSize: '12px', paddingTop: '20px' }}
          >
            <div style={{ color: '#5292D9', fontSize: '5px', padding: '5px' }}>
              ●
            </div>
            <FormattedMessage id="welcome.timeremind" />
          </div>
        </div>
      );
    case 'DELIVERY':
      return (
        <div
          className="d-flex align-items-center"
          style={{ color: '#5292D9', fontSize: '12px', paddingTop: '20px' }}
        >
          <div style={{ color: '#5292D9', fontSize: '5px', padding: '5px' }}>
            ●
          </div>
          <div>
            <FormattedMessage id="welcome.timeremind.delivery.notice" />
          </div>
        </div>
      );
    case 'PICK_UP':
      return (
        <div
          className="row"
          style={{ color: '#5292D9', fontSize: '16px', paddingTop: '20px' }}
        >
          <div className="text-center">
            <FormattedMessage
              id="welcome.pickup.timeremind.onlineTime"
              values={{
                startTime: webStoreVo?.startTime,
                endTime: webStoreVo?.endTime,
              }}
            />
          </div>

          <div className="text-center">
            <FormattedMessage
              id="welcome.pickup.timeremind.pickupTime"
              values={{
                pickupEndTime: lastPickupTime,
              }}
            />
          </div>
        </div>
      );
    default:
      return null;
  }
}

TimeRemind.propTypes = {
  serveType: PropTypes.any,
  webStoreVo: PropTypes.any,
};

export default TimeRemind;
